document.addEventListener("DOMContentLoaded", function () {
    const track = document.querySelector(".slider-trackM");
    const originalSlides = Array.from(track.querySelectorAll(".slideM"));
    if (!track || originalSlides.length === 0) return;

    const slideWidth = originalSlides[0].offsetWidth;
    const visibleSlides = 3;
    const totalSlides = originalSlides.length;

    // Clone slides for infinite loop
    for (let i = 0; i < visibleSlides; i++) {
      track.appendChild(originalSlides[i].cloneNode(true));
    }
    for (let i = totalSlides - visibleSlides; i < totalSlides; i++) {
      track.insertBefore(originalSlides[i].cloneNode(true), track.firstChild);
    }

    let currentIndex = visibleSlides;

    function updateSlider(animate = true) {
      track.style.transition = animate ? "transform 0.5s ease-in-out" : "none";
      track.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
    }

    updateSlider(false); // Set initial offset

    function nextSlide() {
      currentIndex++;
      updateSlider();

      if (currentIndex >= totalSlides + visibleSlides) {
        setTimeout(() => {
          currentIndex = visibleSlides;
          updateSlider(false);
        }, 500);
      }
    }

    function prevSlide() {
      currentIndex--;
      updateSlider();

      if (currentIndex < visibleSlides) {
        setTimeout(() => {
          currentIndex = totalSlides;
          updateSlider(false);
        }, 500);
      }
    }

    document.querySelector(".nextM").addEventListener("click", nextSlide);
    document.querySelector(".prevM").addEventListener("click", prevSlide);
  });